export default __webpack_public_path__ + "static/media/placeholder_portfolio03-es-mobile.660fc524.png";